import request from 'superagent'
import types from '../types'

import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let authUrl = `${protocol}//${hostname}:${api_port}/auth`
if(api_port==='')
  authUrl = `${protocol}//${hostname}/auth`

const addAppProcessUserRequested = () => ({
  type: types.ADD_APP_PROCESS_USER_REQUESTED,
  payload: null
})

const addAppProcessUserRejected = (error: any) => ({
  type: types.ADD_APP_PROCESS_USER_REJECTED,
  payload: error
})

const addAppProcessUserFulfilled = (data: any) => ({
  type: types.ADD_APP_PROCESS_USER_FULFILLED,
  payload: data
})

export const addAppProcessUser = (data: { email: string; firstName: string; lastName: string; roleId: number; status: string; enabled: boolean }) => {
  return (dispatch: any) => {
    dispatch(addAppProcessUserRequested())
    request
      .post(`${authUrl}/appProcess/user`)
      .set('Accept', 'application/json')
	    .send(data)
      .then((response) => {
        dispatch(addAppProcessUserFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(addAppProcessUserRejected(error))
      })
  }
}

const validateUserRequested = () => ({
  type: types.VALIDATE_USER_REQUESTED,
  payload: null
})

const validateUserRejected = (error: any) => ({
  type: types.VALIDATE_USER_REJECTED,
  payload: error
})

const validateUserFulfilled = (data: any) => ({
  type: types.VALIDATE_USER_FULFILLED,
  payload: data
})

export const validateUser = (data: { email: string }) => {
  return (dispatch: any) => {
    dispatch(validateUserRequested())
    request
      .post(`${authUrl}/appProcess/user/validation`)
      .set('Accept', 'application/json')
      .send(data)
      .then((response) => {
        dispatch(validateUserFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(validateUserRejected(error))
      })
  }
}